import Select from '@mui/material/Select';
import { type SelectProps, type SelectVariants } from '@mui/material/Select/Select';

import ExpandMoreIcon from 'assets/icons/icn _ 16px _down.svg?react';
import { TMXBaseInput } from 'components/inputs/TMXBaseInput';
import { useStyles } from 'components/selectors/tmxSelector/styles';

export interface TMXSelectProps<T> {
  field?: {
    name: string;
    value: any;
    onChange: SelectProps<T>['onChange'];
  };
  form?: {
    touched: boolean;
    error: boolean;
    setFieldError: any;
    setFieldTouched: any;
    setFieldValue?: any;
  };
  multiple?: boolean;
  displayEmpty?: boolean;
  variant?: SelectVariants;
  value?: T | '';
}

export type MuiSelectProps<T = unknown> = Omit<SelectProps<T>, 'multiple' | 'displayEmpty' | 'variant'> &
  TMXSelectProps<T>;

const TMXSelect = <T,>({ children, displayEmpty, multiple, variant, ...props }: MuiSelectProps<T>) => {
  const { classes } = useStyles();

  const renderIcon = (iconProps) => <ExpandMoreIcon {...iconProps} fontSize="small" style={{ top: 'unset' }} />;

  return (
    <Select
      {...props}
      {...(!!displayEmpty && { displayEmpty: true })}
      {...(!!multiple && { multiple: true })}
      className={`${classes.selector} ${props.className ?? ''}`}
      IconComponent={renderIcon}
      input={<TMXBaseInput />}
      MenuProps={{ classes: { paper: classes.selectorPaper, list: classes.selectorList } }}
      variant={variant || 'outlined'}
    >
      {children}
    </Select>
  );
};

export default TMXSelect;
